import { makeStyles } from '@mui/styles';
import TextField from 'apollo-react/components/TextField';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';

import { useTranslation } from '../../../custom-hooks/useTranslation';
import { getUITA } from '../../../utils/commonUtils';
import { isNilOrEmpty } from '../../../utils/ramdaUtils';
import { FCM_HIDDEN_CONTROL_STYLES } from '../../constants/runtime.constants';
import { showAsteriskBefore } from '../../utils/form-manager.utils';

const useStyles = makeStyles({
  hiddenControl: FCM_HIDDEN_CONTROL_STYLES,
  input: {
    '& .MuiInputBase-root.Mui-disabled': {
      '& input': {
        border: '1px solid #d9d9d9',
      },
    },
  },
  disabledWithError: {
    '& .MuiInputBase-root.Mui-disabled': {
      '& input': {
        border: '2px solid #bd0100 !important',
      },
    },
  },
});

function TextBox({
  label,
  actions,
  className,
  isRequired,
  isDisabledWithZoom,
  value = '',
  error,
  inTable,
  isEditor,
  inFieldGroup,
  isHiddenLabel,
  maxLength,
  entityName,
  fieldName,
  instanceId,
  disabled,
  isControlHiddenFCM,
  secure,
}) {
  const classes = useStyles();
  const [newValue, setValue] = useState(value);
  const translation = useTranslation();

  // Update inner state when `value` is changed from outside.
  useEffect(() => {
    setValue(value);
  }, [value]);

  const onBlurHandler = ({ target: { value: v } }) => {
    const _value = v.trim();
    setValue(_value);

    if (isNilOrEmpty(_value) && isNilOrEmpty(value)) {
      return;
    }

    actions.updateControlValue(_value);
  };

  const hiddenLabel = inTable || (inFieldGroup && isHiddenLabel);

  return (
    <TextField
      id={instanceId}
      type={secure ? 'password' : 'text'}
      label={hiddenLabel ? '' : label}
      asteriskPosition={showAsteriskBefore(inTable ? '' : label, inTable) ? 'before' : 'after'}
      fullWidth
      style={{
        width: '100%',
        maxWidth: 568,
        minWidth: 184,
        flex: '1 1 100%',
      }}
      className={classNames(
        className,
        isControlHiddenFCM ? classes.hiddenControl : '',
        isEditor && classes.input,
        error && isDisabledWithZoom ? classes.disabledWithError : ''
      )}
      data-hidden-fcm={isControlHiddenFCM}
      onBlur={onBlurHandler}
      onChange={({ target: { value } }) => setValue(value)}
      required={isRequired}
      value={newValue ?? ''}
      error={error}
      disabled={isEditor || isDisabledWithZoom || disabled}
      inputProps={{
        maxLength,
        title: isRequired && !value ? translation('Please fill out this field.') : '',
        'aria-label': label,
      }}
      ui-ta={getUITA('FormCtrl', 'SSTextBox', entityName, fieldName)}
    />
  );
}

export default TextBox;
